import React, { Fragment } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ModalLisCiu = ({
  modalOpen,
  toggleModal,
  modalTitle,
  selecCiu,
  handleKeyUpCiu,
  listaCiu,
}) => {
  return (
    <Dialog
      open={modalOpen}
      onClose={toggleModal}
      maxWidth="lg"
      fullWidth
      disableEscapeKeyDown
      slotProps={{
        backdrop: {
          invisible: false,
          onClick: (event) => event.stopPropagation(),
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          {modalTitle}
          <IconButton
            aria-label="close"
            onClick={toggleModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Fragment>
          {/* Search input */}
          <Box sx={{ mb: 2 }}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Buscar..."
              onChange={handleKeyUpCiu}
              onKeyUp={handleKeyUpCiu}
            />
          </Box>

          {/* Table for data */}
          <TableContainer
            component={Paper}
            sx={{ height: "calc(60vh)", overflowY: "auto" }}
          >
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "150px" }}>Código</TableCell>
                  <TableCell>Denominación</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listaCiu && listaCiu.length > 0 ? (
                  listaCiu.map((item, index) => (
                    <TableRow
                      hover
                      key={index}
                      onClick={() => {
                        selecCiu(item);
                      }}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell>{item.codCid}</TableCell>
                      <TableCell>{item.ciudad}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No hay datos disponibles.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Fragment>
      </DialogContent>
    </Dialog>
  );
};

export default ModalLisCiu;
